<div class="widget-container" #ControlCharDiv>
    <div class="row">
        <div class="col-12">
            <app-control-chart 
                [heading]="heading" 
                [config]="config" 
                [data]="data" 
                [AllcommentData]="AllcommentData" 
                [item]="item" 
                [pageKey]="pageKey" 
                [parentData]="parentData"
                [error_name]="error_name"
                >
            </app-control-chart>
        </div>
    </div>
</div>